import { DateInt12, DateInt8, getDate12AsObject, getDate8AsObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Document } from './document.model';
import { Location } from './location.model';
import { Partner } from './partner.model';
import { User } from './user.model';


@CwtModel({ name: 'stay', path: '/stay' })
export class Stay extends ApiData {
    startDate?: DateInt8;
    endDate?: DateInt8;
    camping?: Partner;
    firstName?: string;
    lastName?: string;
    email?: string;
    language?: string;
    isEmailSent?: boolean;
    emailSentDate?: DateInt12;
    user?: User;
    isInvitation?: boolean;
    linkedToUserDate?: DateInt12;
    placeNum?: string;
    location?: Location;
    documents?: StayDocument[];

    public get partner(): Partner { return this.camping; }
    public set partner(v: Partner) { this.camping = v; }

    public startDateAsObject?: Date;
    public endDateAsObject?: Date;

    constructor(json: any) {
        super(json);
        if (this.startDate) this.startDateAsObject = getDate8AsObject(this.startDate);
        if (this.endDate) this.endDateAsObject = getDate8AsObject(this.endDate);
    }

    fieldDictionary() {
        return {
            camping: Partner,
            location: Location
        };
    }
}

export interface StayDocument extends Document {
    name?: string;
}
